<template>
  <div class="privacy-policy-page">
    <!-- Main Content -->
    <main class="main-content">
      <div class="container">
        <div class="privacy-content">
          <h1 class="page-title">Política de Privacidade</h1>
          
          <div class="last-updated">
            <p><strong>Última atualização:</strong> {{ lastUpdated }}</p>
          </div>

          <section class="policy-section">
            <h2>1. Introdução</h2>
            <p>
              O Templo EDEM valoriza e respeita a privacidade de todos os visitantes do nosso site. 
              Esta Política de Privacidade descreve como tratamos as informações quando você visita 
              nosso website <strong>www.temploedem.com.br / www.temploedem.org.br</strong>.
            </p>
          </section>

          <section class="policy-section">
            <h2>2. Coleta de Dados</h2>
            <p>
              <strong>Informamos que NÃO coletamos dados pessoais dos usuários.</strong> 
              Nosso site funciona de forma totalmente anônima, sem requerer cadastros, 
              formulários de contato que armazenem informações, ou qualquer tipo de 
              coleta de dados pessoais.
            </p>
          </section>

          <section class="policy-section">
            <h2>3. Cookies e Tecnologias Similares</h2>
            <p>
              Nosso site pode utilizar cookies técnicos essenciais apenas para o 
              funcionamento básico das páginas. Estes cookies não coletam informações 
              pessoais e são necessários para a navegação adequada do site.
            </p>
          </section>

          <section class="policy-section">
            <h2>4. Logs do Servidor</h2>
            <p>
              Como qualquer site na internet, nosso servidor pode registrar automaticamente 
              informações técnicas básicas como endereço IP, tipo de navegador e páginas 
              acessadas. Essas informações são utilizadas exclusivamente para fins de 
              segurança e manutenção técnica, não sendo utilizadas para identificar usuários.
            </p>
          </section>

          <section class="policy-section">
            <h2>5. Compartilhamento de Informações</h2>
            <p>
              Uma vez que não coletamos dados pessoais, não há informações para serem 
              compartilhadas com terceiros. Nosso site não possui integração com 
              redes sociais, sistemas de análise que coletem dados pessoais ou 
              qualquer ferramenta de rastreamento.
            </p>
          </section>

          <section class="policy-section">
            <h2>6. Segurança</h2>
            <p>
              Mesmo não coletando dados pessoais, mantemos medidas de segurança 
              adequadas para proteger nosso site contra acessos não autorizados 
              e garantir a integridade do conteúdo disponibilizado.
            </p>
          </section>

          <section class="policy-section">
            <h2>7. Links Externos</h2>
            <p>
              Nosso site pode conter links para outros websites. Não nos responsabilizamos 
              pelas práticas de privacidade de sites externos. Recomendamos que você 
              leia as políticas de privacidade de qualquer site que visitar através 
              de nossos links.
            </p>
          </section>

          <section class="policy-section">
            <h2>8. Direitos dos Usuários</h2>
            <p>
              Por não coletarmos dados pessoais, não há informações para serem 
              acessadas, corrigidas ou excluídas. Sua privacidade está garantida 
              desde o momento em que você acessa nosso site.
            </p>
          </section>

          <section class="policy-section">
            <h2>9. Menores de Idade</h2>
            <p>
              Nosso site é adequado para todas as idades. Por não coletarmos 
              dados pessoais, não há restrições específicas relacionadas ao 
              acesso por menores de idade.
            </p>
          </section>

          <section class="policy-section">
            <h2>10. Alterações nesta Política</h2>
            <p>
              Reservamo-nos o direito de atualizar esta Política de Privacidade 
              a qualquer momento. Qualquer alteração será publicada nesta página 
              com a data de atualização correspondente.
            </p>
          </section>

          <section class="policy-section">
            <h2>11. Contato</h2>
            <p>
              Se você tiver dúvidas sobre esta Política de Privacidade, 
              entre em contato conosco através dos canais disponíveis em nosso site.
            </p>
          </section>

          <div class="declaration">
            <p class="highlight">
              <strong>Declaração:</strong> O Templo EDEM se compromete com a transparência 
              e o respeito à privacidade. Esta política reflete nosso compromisso de 
              não coletar dados pessoais de nossos visitantes.
            </p>
          </div>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage',
  data() {
    return {
      lastUpdated: '31 de julho de 2025',
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    // Scroll to top when component is mounted
    window.scrollTo(0, 0);
  }

}
</script>

<style scoped>
/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.privacy-policy-page {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top:6vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header */
.header {
  background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
  color: white;
  padding: 1rem 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.site-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-decoration: none;
}

.nav {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #ecf0f1;
  text-decoration: underline;
}

/* Main Content */
.main-content {
  flex: 1;
  padding: 3rem 0;
  background: #f8f9fa;
}

.privacy-content {
  background: white;
  padding: 3rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  max-width: 800px;
  margin: 0 auto;
}

.page-title {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  text-align: center;
  border-bottom: 3px solid #ffefbc;
  padding-bottom: 1rem;
}

.last-updated {
  text-align: center;
  margin-bottom: 2rem;
  padding: 1rem;
  background: #ffefbc;
  border-radius: 5px;
  border-left: 4px solid #ffefbc;
}

.policy-section {
  margin-bottom: 2.5rem;
}

.policy-section h2 {
  color: #2c3e50;
  font-size: 1.4rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #ecf0f1;
}

.policy-section p {
  margin-bottom: 1rem;
  text-align: justify;
}

.declaration {
  margin-top: 3rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #e8f5e8 0%, #f0f8f0 100%);
  border-radius: 8px;
  border-left: 5px solid #27ae60;
}

.highlight {
  color: #27ae60;
  font-weight: 600;
}

/* Footer */
.footer {
  background: #ffefbc;
  color: black;
  padding: 2rem 0;
  text-align: center;
}

.footer .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-links {
  display: flex;
  gap: 1rem;
}

.footer-link {
  color: #0a5162;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #3498db;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav {
    gap: 1rem;
  }

  .privacy-content {
    padding: 2rem 1.5rem;
    margin: 0 1rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .footer .container {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }

  .privacy-content {
    padding: 1.5rem 1rem;
  }

  .page-title {
    font-size: 1.8rem;
  }

  .nav {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>